module.exports = __webpack_public_path__ + "static/media/12_negro.8a408f7b.svg";